// extracted by mini-css-extract-plugin
export default {"link":"bM-z","disabled":"cM-z"};